<section class="container sign-container payment-choose-plan-container" id="paymentChoosePlan">
	<header class="background-header">
		<img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img"
			[ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
		<section class="navbar-brand navbar-brand-choose-plan">
			<img class="main-logo main-img-about-me" src="../../assets/img/{{themeService.theme}}/main-logo.png"
				alt="Company Logo" width="125px">
		</section>
	</header>
	<header class="mobile-header">
		<img src="../../assets/img/{{themeService.theme}}/main-logo.png" alt="Company Logo" width="125px">
	</header>
	<section class="container choose-plan-container" [ngClass]="{'bigger-choose-plan-container': showExportDataBtn}">
		<ng-container *ngIf="showExportDataBtn">
			<div class="title-no-subscription">Access your Zenplans data</div>
			<div class="subtitle-no-subscription">Your subscription is not active. You can subscribe to continue
				using Zenplans, or export your data at any time.</div>
			<div class="container-subscription-export">
				<form [formGroup]="choosePlanFormGroup" class="card-payment-choose-plan">
					<section class="price-boxes">
						<!-- <div class="items" [ngClass]="{selected:chosenPlan=='perYear'}"
							(click)="setPaymentType('perYear')">
							<div class="ovale">
								<span>Discounted Price</span>
							</div>
							<div class="price-content">
								<div class="price">Annual Plan</div>
								<div class="per">£50/year</div>
							</div>
							<div class="round" [ngClass]="{roundClass:chosenPlan=='perYear'}">
								<i class="fa fa-2x fas fa-check"></i>
							</div>
						</div> -->
						<div class="title-section">Continue access</div>
						<div class="text">Keep your Zenplan active to view, update and share your plan at any time.
						</div>
						<div class="text">Annual plan - <span *ngIf="refCode">£{{price}}</span>
														<span *ngIf="!refCode">£60</span>. 
										Cancel any time.
						</div>

						<section class="cancel-payment">
							<input type="submit" class="btn btn-primary primary-default-btn payment-complete-btn"
								value="Subscribe" (click)="onSubmit()">
						</section>
					</section>

					<!-- <div class="cancel-text">
						<span>Subscription terms: You will now be charged £50.<br> You will then be charged £50 every
							following
							year. Cancel anytime.</span>
					</div> -->
				</form>
				<div class="export-data-info">
					<div class="title-section">Export data</div>
					<div class="text">Download everything stored in your Zenplans.</div>
					<div class="buttons">
						<button class="btn btn-primary primary-default-btn export" (click)="exportData()">Export
							your
							data
						</button>
					</div>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="!showExportDataBtn">
			<form [formGroup]="choosePlanFormGroup" class="card-payment-choose-plan">
				<section class="price-boxes">
					<div class="items" [ngClass]="{selected:chosenPlan=='perYear'}" (click)="setPaymentType('perYear')">
						<div class="ovale">
							<span>Discounted Price</span>
						</div>
						<div class="price-content">
							<div class="price">Annual Plan</div>
							<div class="per" *ngIf="refCode">£{{price}}</div>
							<div class="per" *ngIf="!refCode">£60/year</div>
						</div>
						<div class="round" [ngClass]="{roundClass:chosenPlan=='perYear'}">
							<i class="fa fa-2x fas fa-check"></i>
						</div>
					</div>
				</section>
				<section class="cancel-payment">
					<input type="submit" class="btn btn-primary primary-default-btn payment-complete-btn"
						value="Choose Plan" (click)="onSubmit()">
				</section>
				<div class="cancel-text">
					<span>
						Subscription terms: You will now be charged 
						<span *ngIf="refCode">£{{price}}</span>
						<span *ngIf="!refCode">£60</span>.
						<br> 
						You will then be charged 
						<span *ngIf="refCode">£{{price}}</span>
						<span *ngIf="!refCode">£60</span> 
						every
						following
						year. 
						
						Cancel anytime.
					</span>
				</div>
			</form>
		</ng-container>
	</section>
</section>